    export const environment = {
        production: false,

        // B2C Policies
        b2cPolicies: {
            names: {
                signUpSignIn: "B2C_1_UAT_Eagle_SignInAndSignUp",
                editProfile: "B2C_1_UAT_Eagle_SignIn",
                forgotPassword: "B2C_1_UAT_Eagle_PasswordReset"
            },
            authorities: {
                signUpSignIn: "https://eagleb2cdev.b2clogin.com/eagleb2cdev.onmicrosoft.com/B2C_1_UAT_Eagle_SignInAndSignUp",
                editProfile: "https://eagleb2cdev.b2clogin.com/eagleb2cdev.onmicrosoft.com/B2C_1_UAT_Eagle_SignIn",
                forgotPassword: "https://eagleb2cdev.b2clogin.com/eagleb2cdev.onmicrosoft.com/B2C_1_UAT_Eagle_PasswordReset"
            },
            authorityDomain: "eagleb2cdev.b2clogin.com"
        },

        // MSAL Configuration
        msalConfig: {
            clientId: '38b668b1-6c03-4463-8189-1d7925cc0c15',
            redirectUri: 'https://merckepapenrollment-uat.azurewebsites.net',
        },

        // Protected Resources
        protectedResources: {
            todoListApi: {
                endpoint: "https://merckepapenrollment-uat.azurewebsites.net",
                scopes: ["https://eagleb2cdev.onmicrosoft.com/api/tasks.read"]
            }
        },
        //Portal Config
        programURL: 'https://merckepapenrollment-uat.azurewebsites.net',
        baseURL: 'https://eaglepharmacy-dev.azure-api.net/epapenrollUAT/api',
        OcpApimKey: '1888eba686a54f14b360c3a20d823ebc',
        apiVersion: 'v2',
        manufacturerID: '10050',
        programID: '11125',
        instrumentationKey:'b2a46289-825c-4c53-905d-2ccedb26103c'

    };
